import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoaded: false,
  karmaEarnOffer: {},
};

const karmaEarnOfferSlice = createSlice({
  name: 'karmaEarnOffer',
  initialState,
  reducers: {
    receiveItem: (state, { payload }) => ({
      ...state,
      isLoaded: true,
      karmaEarnOffer: payload,
    }),
    reset: () => initialState,
  },
});

export default karmaEarnOfferSlice;
